module.exports = __webpack_public_path__ + "img/static_noise_256x256.3e4bf22d.gif";